import React, { useState } from 'react';
import { Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import { setRompslompInvoiceDetail } from '../../../services/RompslompService';
import { PasswordModal } from './RompslompSending';
import { apiMessage } from './rompslompUtils';

// Rompslomp invoice detail: ONE LINE PER BTW RATE (default) or PER PRODUCT. Super admin + the user's own password; audit-logged on the server.
export default function RompslompInvoiceDetail({ sending, reload }) {
    const { t } = useTranslation();
    const [ask, setAsk] = useState(false);
    const current = sending.invoice_detail || 'per_product';
    const other = current === 'per_rate' ? 'per_product' : 'per_rate';

    const change = async (password) => {
        try {
            await setRompslompInvoiceDetail(other, password);
            toast.success(t('rompslomp.detail.saved'));
            setAsk(false);
            reload();
        } catch (err) { toast.error(apiMessage(err, t, 'rompslomp.errors.generic')); }
    };

    return (
        <div data-testid="invoice-detail">
            <p className="text-muted">{t('rompslomp.detail.hint')}</p>
            <p><strong data-testid="invoice-detail-current">{t(`rompslomp.detail.modes.${current}`)}</strong></p>
            <p className="small">{t(`rompslomp.detail.explain.${current}`)}</p>
            <Button variant="outline-secondary" onClick={() => setAsk(true)} data-testid="invoice-detail-change">{t(`rompslomp.detail.switchTo.${other}`)}</Button>
            <PasswordModal show={ask} onHide={() => setAsk(false)} title={t(`rompslomp.detail.switchTo.${other}`)} text={t(`rompslomp.detail.explain.${other}`)}
                confirmLabel={t('rompslomp.sending.confirm')} onConfirm={change} />
        </div>
    );
}
